import api from '../../../Libs/Services/api';

const ProductService = {
    // ==================== AI ====================
    aiSuggest: (data) => api.post('Pro_Ex_AI/suggest', data),
    translateLanguages: (data) => api.post('Pro_Ex_AI/translateLanguages', data),
    translateProduct: (data) => api.post('Pro_Ex_AI/translate', data),
    translateFields: (data) => api.post('Pro_Ex_AI/translateFields', data),
    translateBatch: (data) => api.post('Pro_Ex_AI/translateBatch', data),
    translateSave: (data) => api.post('Pro_Ex_AI/translateSave', data),

    // ==================== İçerik denetim (audit) ====================
    contentAudit: (data) => api.post('ProductContentAudit/get', data),
    contentAuditRecent: (data) => api.post('ProductContentAudit/recent', data),

    // ==================== Product List ====================
    getProductList: (data) => api.post('Pro_Ex_Product_List/get', data),
    removeProduct: (data) => api.post('Pro_Ex_Product_List/removeProduct', data),
    toggleProductDisabled: (data) => api.post('Pro_Ex_Product_List/toggleDisabled', data),
    cloneProduct: (data) => api.post('Pro_Ex_Product_List/clone', data),

    // ==================== Create Product ====================
    createGetData: (data) => api.post('Pro_Ex_Create_Product/getData', data),
    createSet: (data) => api.post('Pro_Ex_Create_Product/set', data),
    finishProduct: (data) => api.post('Pro_Ex_Create_Product/finish', data),

    // ==================== Categories ====================
    getCategoriesOldData: (data) => api.post('Pro_Ex_Categories/getOldData', data),
    updateCategories: (data) => api.post('Pro_Ex_Categories/update', data),
    setCategories: (data) => api.post('Pro_Ex_Categories/set', data),

    // ==================== Covid ====================
    getCovidOldData: (data) => api.post('Pro_Ex_Covid/getOldData', data),
    updateCovid: (data) => api.post('Pro_Ex_Covid/update', data),
    setCovid: (data) => api.post('Pro_Ex_Covid/set', data),

    // ==================== Add Information ====================
    getAddInformationOldData: (data) => api.post('Pro_Ex_AddInformation/getOldData', data),
    updateAddInformation: (data) => api.post('Pro_Ex_AddInformation/update', data),
    setAddInformation: (data) => api.post('Pro_Ex_AddInformation/set', data),

    // ==================== Extras ====================
    getExtrasData: (data) => api.post('Pro_Ex_Extras/getData', data),
    getExtrasDataById: (data) => api.post('Pro_Ex_Extras/getDataById', data),
    getExtrasDefinitions: (data) => api.post('Pro_Ex_Extras/getDefinitions', data),
    setExtras: (data) => api.post('Pro_Ex_Extras/Set', data),
    setStepExtra: (data) => api.post('Pro_Ex_Extras/setStepExtra', data),
    deleteExtra: (data) => api.post('Pro_Ex_Extras/deleteExtra', data),
    statusChangeExtra: (data) => api.post('Pro_Ex_Extras/statusChangeExtra', data),
    setExtrasMedia: (data, config) => api.post('Pro_Ex_Extras/setMedia/', data, config),

    // ==================== Meeting Point ====================
    getMeetingPointOldData: (data) => api.post('Pro_Ex_MeetingPoint/getOldData', data),
    updateMeetingPoint: (data) => api.post('Pro_Ex_MeetingPoint/update', data),
    setMeetingPoint: (data) => api.post('Pro_Ex_MeetingPoint/set', data),

    // ==================== Market & Guide ====================
    getMarketGuideOldData: (data) => api.post('Pro_Ex_Market_Guide/getOldData', data),
    updateMarketGuide: (data) => api.post('Pro_Ex_Market_Guide/update', data),
    setMarketGuide: (data) => api.post('Pro_Ex_Market_Guide/set', data),

    // ==================== Language & Title ====================
    getLanguageTitleOldData: (data) => api.post('Pro_Ex_Language_Title/getOldData', data),
    updateLanguageTitle: (data) => api.post('Pro_Ex_Language_Title/update', data),
    setLanguageTitle: (data) => api.post('Pro_Ex_Language_Title/set', data),

    // ==================== Highlights & Description ====================
    getHighlightsAndDescOldData: (data) => api.post('Pro_Ex_HighligthsAndDesc/getOldData', data),
    updateHighlightsAndDesc: (data) => api.post('Pro_Ex_HighligthsAndDesc/update', data),
    setHighlightsAndDesc: (data) => api.post('Pro_Ex_HighligthsAndDesc/set', data),

    // ==================== Information Guest ====================
    getInformationGuestOldData: (data) => api.post('Pro_Ex_InformationGuest/getOldData', data),
    updateInformationGuest: (data) => api.post('Pro_Ex_InformationGuest/update', data),
    setInformationGuest: (data) => api.post('Pro_Ex_InformationGuest/set', data),

    // ==================== Media ====================
    getMedia: (data) => api.post('Pro_Ex_Media/get', data),
    setMedia: (data, config) => api.post('Pro_Ex_Media/set/', data, config),
    setMediaOrdered: (data) => api.post('Pro_Ex_Media/setOrdered', data),
    removeMedia: (data) => api.post('Pro_Ex_Media/removeMedia', data),
    completeMedia: (data) => api.post('Pro_Ex_Media/complete', data),

    // ==================== Availability ====================
    getAvaibilityDefinitions: (data) => api.post('Pro_Ex_Avaibility/getDefinitions', data),
    getAvaibility: (data) => api.post('Pro_Ex_Avaibility/getAvaibility', data),
    setScheduleWeek: (data) => api.post('Pro_Ex_Avaibility/setScheduleWeek', data),
    getSchedulesWeekStatus: (data) => api.post('Pro_Ex_Avaibility/getSchedulesWeekStatus', data),
    openCloseDay: (data) => api.post('Pro_Ex_Avaibility/OpenCloseDay', data),

    // ==================== Schedule (V1) ====================
    getSchedule: (data) => api.post('Pro_Ex_PR_Schedule/get', data),
    getScheduleDefinitions: (data) => api.post('Pro_Ex_PR_Schedule/getDefinitions', data),
    setSchedule: (data) => api.post('Pro_Ex_PR_Schedule/set', data),
    deleteScheduleById: (data) => api.post('Pro_Ex_PR_Schedule/deleteScheduleById', data),
    checkScheduleDate: (data) => api.post('Pro_Ex_PR_Schedule/checkScheduleDate', data),
    updateScheduleDate: (data) => api.post('Pro_Ex_PR_Schedule/updateScheduleDate', data),
    getSelectedScheduleDate: (data) => api.post('Pro_Ex_PR_Schedule/getSelectedScheduleDate', data),
    getScheduleDateById: (data) => api.post('Pro_Ex_PR_Schedule/getScheduleDateById', data),
    getScheduleGuideData: (data) => api.post('Pro_Ex_PR_Schedule/getGuideData', data),
    setScheduleGuideData: (data) => api.post('Pro_Ex_PR_Schedule/setGuideData', data),
    getScheduleDayStatus: (data) => api.post('Pro_Ex_PR_Schedule/getDayStatus', data),
    setScheduleDayStatus: (data) => api.post('Pro_Ex_PR_Schedule/setDayStatus', data),

    // ==================== Schedule V2 ====================
    getV2CalendarDefinition: (data) => api.post('Pro_Ex_PR_V2_Schedule/getCalendarDefinition', data),
    getV2DataCalendar: (data) => api.post('Pro_Ex_PR_V2_Schedule/getDataCalendar', data),
    getV2AddScheduleDateDefinition: (data) => api.post('Pro_Ex_PR_V2_Schedule/getAddScheduleDateDefinition', data),
    getV2TimeList: (data) => api.post('Pro_Ex_PR_V2_Schedule/getTimeList', data),
    getV2TimeListById: (data) => api.post('Pro_Ex_PR_V2_Schedule/getTimeListById', data),
    setV2TimeList: (data) => api.post('Pro_Ex_PR_V2_Schedule/setTimeList', data),
    removeV2TimeSlot: (data) => api.post('Pro_Ex_PR_V2_Schedule/removeTimeSlot', data),
    getV2GuideList: (data) => api.post('Pro_Ex_PR_V2_Schedule/getGuideList', data),
    getV2Schedule: (data) => api.post('Pro_Ex_PR_V2_Schedule/getSchedule', data),
    setV2Schedule: (data) => api.post('Pro_Ex_PR_V2_Schedule/setSchedule', data),
    setV2WeekDayStatus: (data) => api.post('Pro_Ex_PR_V2_Schedule/setWeekDayStatus', data),
    setV2CloseOpenTime: (data) => api.post('Pro_Ex_PR_V2_Schedule/setCloseOpenTime', data),
    setV2SessionStatus: (data) => api.post('Pro_Ex_PR_V2_Schedule/setSessionStatus', data),
    createV2Session: (data) => api.post('Pro_Ex_PR_V2_Schedule/createSession', data),
    updateV2Quota: (data) => api.post('Pro_Ex_PR_V2_Schedule/updateQuota', data),
    updateV2GuideStatusAndLimit: (data) => api.post('Pro_Ex_PR_V2_Schedule/updateGuideStatusAndLimit', data),
    createV2Guide: (data) => api.post('Pro_Ex_PR_V2_Schedule/createGuide', data),

    // ==================== Schedule V4 ====================
    getV4CalendarData: (data) => api.post('Pro_Ex_PR_V4_Schedule/getCalendarV4Data', data),
    getV4ScheduleDateDefinition: (data) => api.post('Pro_Ex_PR_V4_Schedule/getScheduleDateDefinitionV4', data),
    getV4TimeList: (data) => api.post('Pro_Ex_PR_V4_Schedule/getTimeListV4', data),
    getV4TimeListById: (data) => api.post('Pro_Ex_PR_V4_Schedule/getTimeListByIdV4', data),
    setV4TimeList: (data) => api.post('Pro_Ex_PR_V4_Schedule/setTimeListV4', data),
    removeV4TimeSlot: (data) => api.post('Pro_Ex_PR_V4_Schedule/removeTimeSlotV4', data),
    setV4MonthStatus: (data) => api.post('Pro_Ex_PR_V4_Schedule/setMonthV4status', data),
    setV4WeekStatus: (data) => api.post('Pro_Ex_PR_V4_Schedule/setWeekV4status', data),
    setV4DayOfWeekStatus: (data) => api.post('Pro_Ex_PR_V4_Schedule/setDayOfWeekV4status', data),
    setV4SessionStatus: (data) => api.post('Pro_Ex_PR_V4_Schedule/setSessionV4status', data),
    setV4GuideStatus: (data) => api.post('Pro_Ex_PR_V4_Schedule/setGuideV4status', data),
    setV4Quota: (data) => api.post('Pro_Ex_PR_V4_Schedule/setQuotaV4', data),
    setV4Schedule: (data) => api.post('Pro_Ex_PR_V4_Schedule/setScheduleV4', data),
    setV4ScheduleDate: (data) => api.post('Pro_Ex_PR_V4_Schedule/setSchedule', data),
    updateV4Schedule: (data) => api.post('Pro_Ex_PR_V4_Schedule/updateScheduleV4', data),
    updateV4LimitSchedule: (data) => api.post('Pro_Ex_PR_V4_Schedule/updateLimitScheduleV4', data),
    updateV4QuotaSchedule: (data) => api.post('Pro_Ex_PR_V4_Schedule/updateQuotaScheduleV4', data),

    // ==================== Itinerary ====================
    getItineraryOldData: (data) => api.post('Pro_Ex_Itinerary/getOldData', data),
    updateItinerary: (data) => api.post('Pro_Ex_Itinerary/update', data),
    setItinerary: (data) => api.post('Pro_Ex_Itinerary/set', data),
    getItineraryTree: (data) => api.post('Pro_Ex_Itinerary/getTree', data),
    getItineraryDaily: (data) => api.post('Pro_Ex_Itinerary/getItineraryDaily', data),
    addItineraryDay: (data) => api.post('Pro_Ex_Itinerary/addItineraryDay', data),
    orderedDailyItem: (data) => api.post('Pro_Ex_Itinerary/orderedDailyItem', data),
    removeDailyItem: (data) => api.post('Pro_Ex_Itinerary/removeDailyItem', data),
    updateDayTitle: (data) => api.post('Pro_Ex_Itinerary/updateDayTitle', data),
    updateAccomodation: (data) => api.post('Pro_Ex_Itinerary/updateAccomodation', data),
    getVisitingPoint: (data) => api.post('Pro_Ex_Itinerary/getVisitingPoint', data),
    setVisitingPoint: (data) => api.post('Pro_Ex_Itinerary/setVisitingPoint', data),
    removeVisitingPoint: (data) => api.post('Pro_Ex_Itinerary/removeVisitingPoint', data),
    orderedVisitingPoint: (data) => api.post('Pro_Ex_Itinerary/orderedVisitingPoint', data),
    getItineraryLocation: (data) => api.post('Pro_Ex_Itinerary/getLocation', data),

    // ==================== Pricing (V1) ====================
    getPricingDefinitions: (data) => api.post('Pro_Ex_Pricing/getDefinitions', data),
    setPrices: (data) => api.post('Pro_Ex_Pricing/setPrices', data),
    getAllExtraList: (data) => api.post('Pro_Ex_Pricing/getAllExtraList', data),
    getPriceStrategyDefinition: (data) => api.post('Pro_Ex_Pricing/getPriceStrategyDefinition', data),
    setPriceStrategyWeekly: (data) => api.post('Pro_Ex_Pricing/setPriceStrategyWeekly', data),
    getPriceStrategyWeekly: (data) => api.post('Pro_Ex_Pricing/getPriceStrategyWeekly', data),
    setPriceStrategyMonthly: (data) => api.post('Pro_Ex_Pricing/setPriceStrategyMonthly', data),
    getPriceStrategyMonthly: (data) => api.post('Pro_Ex_Pricing/getPriceStrategyMonthly', data),
    setPriceStrategySession: (data) => api.post('Pro_Ex_Pricing/setPriceStrategySession', data),
    getPriceStrategySession: (data) => api.post('Pro_Ex_Pricing/getPriceStrategySession', data),
    setPriceStrategyLimit: (data) => api.post('Pro_Ex_Pricing/setPriceStrategyLimit', data),
    getPriceStrategyLimit: (data) => api.post('Pro_Ex_Pricing/getPriceStrategyLimit', data),
    setPriceStrategyLastMinute: (data) => api.post('Pro_Ex_Pricing/setPriceStrategyLastMinute', data),
    getPriceStrategyLastMinute: (data) => api.post('Pro_Ex_Pricing/getPriceStrategyLastMinute', data),
    setPriceStrategyFarFuture: (data) => api.post('Pro_Ex_Pricing/setPriceStrategyFarFuture', data),
    getPriceStrategyFarFuture: (data) => api.post('Pro_Ex_Pricing/getPriceStrategyFarFuture', data),
    setPriceStrategyLanguage: (data) => api.post('Pro_Ex_Pricing/setPriceStrategyLanguage', data),
    getPriceStrategyLanguage: (data) => api.post('Pro_Ex_Pricing/getPriceStrategyLanguage', data),

    // ==================== Pricing V2 (Strategy) ====================
    getPricingStrategyData: (data) => api.post('Pro_Ex_PricingStrategy/getData', data),
    setPricingStrategyGuide: (data) => api.post('Pro_Ex_PricingStrategy/setGuide', data),
    setPricingStrategySession: (data) => api.post('Pro_Ex_PricingStrategy/setSession', data),
    setPricingStrategyMonth: (data) => api.post('Pro_Ex_PricingStrategy/setMonth', data),
    setPricingStrategyWeek: (data) => api.post('Pro_Ex_PricingStrategy/setWeek', data),
    setPricingStrategyLimit: (data) => api.post('Pro_Ex_PricingStrategy/setPriceStrategyLimit', data),
    getPricingStrategyLimit: (data) => api.post('Pro_Ex_PricingStrategy/getPriceStrategyLimit', data),
    setPricingStrategyLastMinute: (data) => api.post('Pro_Ex_PricingStrategy/setPriceStrategyLastMinute', data),
    getPricingStrategyLastMinute: (data) => api.post('Pro_Ex_PricingStrategy/getPriceStrategyLastMinute', data),
    setPricingStrategyFarFuture: (data) => api.post('Pro_Ex_PricingStrategy/setPriceStrategyFarFuture', data),
    getPricingStrategyFarFuture: (data) => api.post('Pro_Ex_PricingStrategy/getPriceStrategyFarFuture', data),
    pricingStrategyCustomAdd: (data) => api.post('Pro_Ex_PricingStrategy/customAdd', data),
    pricingStrategyCustomList: (data) => api.post('Pro_Ex_PricingStrategy/customList', data),
    pricingStrategyCustomListStatus: (data) => api.post('Pro_Ex_PricingStrategy/customListStatus', data),
    pricingStrategyCustomOrdered: (data) => api.post('Pro_Ex_PricingStrategy/customOrdered', data),
    getPricingStrategyCustomOldData: (data) => api.post('Pro_Ex_PricingStrategy/getCustomOldData', data),

    // ==================== Pricing Criteria (V1) ====================
    getPricingCriteriaOldData: (data) => api.post('Pro_Ex_Pricing_Criteria/getOldData', data),
    updatePricingCriteria: (data) => api.post('Pro_Ex_Pricing_Criteria/update', data),
    setPricingCriteria: (data) => api.post('Pro_Ex_Pricing_Criteria/set', data),
    updatePricingCriteriaItems: (data) => api.post('Pro_Ex_Pricing_Criteria/updateCriteriaItems', data),
    addPricingCriteriaItem: (data) => api.post('Pro_Ex_Pricing_Criteria/addCriteriaItem', data),
    orderPricingCriteriaItem: (data) => api.post('Pro_Ex_Pricing_Criteria/orderCriteriaItem', data),
    deletePricingCriteriaItem: (data) => api.post('Pro_Ex_Pricing_Criteria/deleteCriteriaItem', data),

    // ==================== Pricing V2 Criteria ====================
    getPricingV2CriteriaData: (data) => api.post('Pro_Ex_PricingV2_Criteria/getData', data),
    setPricingV2CriteriaData: (data) => api.post('Pro_Ex_PricingV2_Criteria/setData', data),
    addPricingV2CriteriaItem: (data) => api.post('Pro_Ex_PricingV2_Criteria/addCriteriaItem', data),
    orderPricingV2CriteriaItem: (data) => api.post('Pro_Ex_PricingV2_Criteria/orderCriteriaItem', data),
    deletePricingV2CriteriaItem: (data) => api.post('Pro_Ex_PricingV2_Criteria/deleteCriteriaItem', data),

    // ==================== Package ====================
    getPackages: (data) => api.post('Pro_Ex_PR_Package/getPackages', data),
    getPackageById: (data) => api.post('Pro_Ex_PR_Package/getPackageById', data),
    getPackageDefinitions: (data) => api.post('Pro_Ex_PR_Package/getDefinitions', data),
    setPackage: (data) => api.post('Pro_Ex_PR_Package/set', data),
    setPackageDetail: (data) => api.post('Pro_Ex_PR_Package/setPackage', data),
    updatePackage: (data) => api.post('Pro_Ex_PR_Package/updatePackage', data),
    setPackageOrdered: (data) => api.post('Pro_Ex_PR_Package/setOrdered', data),
    setPackageStatus: (data) => api.post('Pro_Ex_PR_Package/setStatus', data),
    setPackageClone: (data) => api.post('Pro_Ex_PR_Package/setClone', data),
    setPackageMedia: (data, config) => api.post('Pro_Ex_PR_Package/setMedia/', data, config),

    // ==================== Extra Pricing ====================
    getExtraPricingDefinitions: (data) => api.post('Pro_Ex_Extra_Pricing/getDefinitions', data),
    updateExtraPrice: (data) => api.post('Pro_Ex_Extra_Pricing/updateExtraPrice', data),
    extraChangeStatus: (data) => api.post('Pro_Ex_Extra_Pricing/extraChangeStatus', data),
    extraList: (data) => api.post('Pro_Ex_Extra_Pricing/extraList', data),

    // ==================== Room ====================
    getRoomDefinitions: (data) => api.post('Pro_Ex_PR_Room/getDefinitions', data),
    setRoom: (data) => api.post('Pro_Ex_PR_Room/setRoom', data),

    // ==================== Policy ====================
    getPolicyOldData: (data) => api.post('Pro_Ex_Policy/getOldData', data),
    updatePolicy: (data) => api.post('Pro_Ex_Policy/update', data),
    setPolicy: (data) => api.post('Pro_Ex_Policy/set', data),

    // ==================== Price Currency ====================
    getPriceCurrencyOldData: (data) => api.post('Pro_Ex_PriceCurrency/getOldData', data),
    updatePriceCurrency: (data) => api.post('Pro_Ex_PriceCurrency/update', data),

    // ==================== Features ====================
    getFeaturesOldData: (data) => api.post('Pro_Ex_Features/getOldData', data),
    updateFeatures: (data) => api.post('Pro_Ex_Features/update', data),
    setFeatures: (data) => api.post('Pro_Ex_Features/set', data),

    // ==================== Review ====================
    getReviewOldData: (data) => api.post('Pro_Ex_Review/getOldData', data),
    updateReview: (data) => api.post('Pro_Ex_Review/update', data),
    setReview: (data) => api.post('Pro_Ex_Review/set', data),

    // ==================== Confirmation Process (Reservation) ====================
    getConfirmationProcessOldData: (data) => api.post('Pro_Ex_Confirmation_Process/getOldData', data),
    updateConfirmationProcess: (data) => api.post('Pro_Ex_Confirmation_Process/update', data),
    setConfirmationProcess: (data) => api.post('Pro_Ex_Confirmation_Process/set', data),

    // ==================== Tax & Fee ====================
    getTaxAndFeeOldData: (data) => api.post('Pro_Ex_TaxAndFee/getOldData', data),
    updateTaxAndFee: (data) => api.post('Pro_Ex_TaxAndFee/update', data),
    setTaxAndFee: (data) => api.post('Pro_Ex_TaxAndFee/set', data),

    // ==================== Voucher ====================
    getVoucherOldData: (data) => api.post('Pro_Ex_Voucher/getOldData', data),
    updateVoucher: (data) => api.post('Pro_Ex_Voucher/update', data),

    // ==================== Calculate ====================
    getCalculateSettings: (data) => api.post('Pro_Ex_PR_Calculate/getSettings', data),
    getCalculateCalendar: (data) => api.post('Pro_Ex_PR_Calculate/getCalendar', data),
    getCalculatePackages: (data) => api.post('Pro_Ex_PR_Calculate/getPackages', data),
    getCalculateSessions: (data) => api.post('Pro_Ex_PR_Calculate/getSessions', data),
    getCalculateGuides: (data) => api.post('Pro_Ex_PR_Calculate/getGuides', data),
    getCalculateCriterias: (data) => api.post('Pro_Ex_PR_Calculate/getCriterias', data),
    increaseOrDecreaseQuantity: (data) => api.post('Pro_Ex_PR_Calculate/increaseOrDecreaseQuantity', data),
    increaseOrDecreaseQuantityExtra: (data) => api.post('Pro_Ex_PR_Calculate/increaseOrDecreaseQuantityExtra', data),
};

export default ProductService;
